import {useEffect} from 'react'
import {useTranslation} from 'react-i18next'

import AppSelect from '../../../../../../shared/AppSelect'
import {useViewImageContext} from './ViewImageContext'
import {useViewLandContext} from '../ViewLandContext'

const YieldMapSelector = () => {
  const {t} = useTranslation()
  const viewImageContext = useViewImageContext()
  const viewLandContext = useViewLandContext()
  const {
    changeYieldMap,
    ensureLandYieldMaps,
    getActiveLandImage,
    getLandYieldMapsState,
  } = viewImageContext
  const land = viewLandContext.land
  const landId = land?.land_id
  const activeLandImage = getActiveLandImage(landId)
  const selectedYieldMapId = activeLandImage.selectedYieldMapId || ''
  const {yieldMaps, loading} = getLandYieldMapsState(landId)
  const selectedYieldMap = yieldMaps.find((yieldMap) => yieldMap.id === selectedYieldMapId)
  const resolvedYieldMapId = selectedYieldMap?.id || yieldMaps[0]?.id || ''
  const options = yieldMaps.map((yieldMap) => ({
    label: `${yieldMap.campaign || '-'} - ${
      yieldMap.name || t('images:yield_map_selector.unnamed')
    }`,
    value: yieldMap.id,
  }))

  useEffect(() => {
    if (!landId) {
      return
    }

    ensureLandYieldMaps(landId).catch(() => {})
  }, [ensureLandYieldMaps, landId])

  useEffect(() => {
    if (!landId || selectedYieldMap || yieldMaps.length < 1) {
      return
    }

    changeYieldMap(land, yieldMaps[0].id)
  }, [changeYieldMap, land, landId, selectedYieldMap, yieldMaps])

  const handleChange = (yieldMapId) => {
    changeYieldMap(land, yieldMapId || null)
  }

  const placeholder = loading
    ? t('images:yield_map_selector.loading')
    : t('images:yield_map_selector.empty')

  return (
    <div className="view-land-yield-map-selector">
      <AppSelect
        disabled={yieldMaps.length < 1}
        label={t('images:yield_map_selector.label')}
        loading={loading}
        onChange={handleChange}
        options={options}
        placeholder={placeholder}
        value={resolvedYieldMapId}
      />
      {!loading && yieldMaps.length === 0 && (
        <p className="view-land-yield-map-selector__hint">
          {t('layers:hints.yield_map_missing')}
        </p>
      )}
    </div>
  )
}

export default YieldMapSelector
